function readLocalization() {
    const html = document.documentElement;

    return {
        locale: html.getAttribute('data-locale') || '',
        country: html.getAttribute('data-country') || '',
    };
}

export default readLocalization;
